











import { computed, defineComponent } from '@vue/composition-api';

export default defineComponent({
	props: {
		content: {
			type: String,
			required: true,
		},
	},
	setup(props) {
		const paragraphs = computed(() => props.content.split('\n')
			.map((s) => s.trim())
			.filter(Boolean));
		return {
			paragraphs,
		};
	},
});
